import { render, staticRenderFns } from "./sameLevel.vue?vue&type=template&id=2fd6bb0a&scoped=true&"
import script from "./sameLevel.vue?vue&type=script&lang=js&"
export * from "./sameLevel.vue?vue&type=script&lang=js&"
import style0 from "./sameLevel.vue?vue&type=style&index=0&id=2fd6bb0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd6bb0a",
  null
  
)

export default component.exports